import Vue from 'vue'
import VueRouter from 'vue-router'
import routers from './router'
import title from 'common/title'
import { reload } from '@/config/global'
import store from './../store/index'
import { login } from 'server/login/index'
import { setStore , getStore , getQueryString} from './../config/global'
Vue.use(VueRouter)

const routes = [{
  path: '/',
  redirect: '/home'
}, ]
Object.values(routers).forEach(router => {
  routes.push(...router)
})
const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

//路由前置守卫
router.beforeEach((to, from, next) => {
  if (process.env.NODE_ENV === 'development') {
    // setStore('token', '7AFEFE1D-BAD8-2C1B-BE28-5794A8032912')
    next()
  }
  else {
    let token = getStore('token')
    // alert(window.location.href.token);
    if (token) {
      next()
    } else {
      let tokenQuery = getQueryString(token)
      // let token = getStore('token')
      if (tokenQuery) {
        setStore('token', tokenQuery)
        next()
      } else {
        // 微信授权
        reload()
      }
    }
  }
})

//路由后置守卫
router.afterEach((to, from) => {
  window.document.title = title[to.name];
})


export default router
